module.exports = __webpack_public_path__ + "static/media/productsBcg.10ea9462.webp";